export default __webpack_public_path__ + "static/backstage-map-domain-731c0818bc4618ad06bd9de4342da213.png";